import { useViewport } from "@faire/web--source/ui/hooks/useViewport";

import { TelemetryManager } from "../../opentelemetry/TelemetryManager";
import { generateTracingMetadata } from "../../tracing/generateTracingMetadata";

import { TrackResultCallback } from "./types";
import {
  ActionName,
  LoadTimingResult,
  LoadTimingStatus,
  LoadTimingType,
} from "./types";

export const useDefaultTrackResultCallback = (
  userToken: string
): TrackResultCallback => {
  const { isDesktopAndAbove, isMobile } = useViewport();
  return (
    name: ActionName,
    status: LoadTimingStatus,
    loadType: LoadTimingType | undefined,
    result: LoadTimingResult
  ) => {
    const metadata = generateTracingMetadata({
      name,
      loadType,
      status,
      result,
      userToken,
      isDesktopAndAbove,
      isMobile,
    });

    TelemetryManager.get().endTrace(`uplt-${name}`, metadata);
  };
};
